export default __webpack_public_path__ + "static/media/inlaks.8ab31877.png";